import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { CandidateSendOutreachEmailModalComponent } from './candidate-send-outreach-email-modal.component';
import { SendCandidateOutreachEmailModule } from 'src/app/shared/send-candidate-outreach-email/send-candidate-outreach-email.module';

@NgModule({
  declarations: [CandidateSendOutreachEmailModalComponent],
  imports: [
    CommonModule,
    FormsModule,
    SendCandidateOutreachEmailModule
  ],
  exports: [CandidateSendOutreachEmailModalComponent],
  entryComponents: [CandidateSendOutreachEmailModalComponent]
})
export class CandidateSendOutreachEmailModalModule { }
